<p [id]="spanTooltip.id"
  [class]="'span-tooltip__ellipsis span-tooltip__ellipsis--multiline-' + multiline"
  pTooltip="{{isDeleted?spanTooltip.tooltipText +' ('+ ('common.inactive-user' | afTranslate)+')':spanTooltip.tooltipText}}"
  [tooltipPosition]="tooltipPosition"
  [tooltipDisabled]="showTooltip()">
  <span [id]="'span-'+spanTooltip.id">
    <span [ngClass]="{'span-tooltip__line-through': isDeleted}">{{text}}</span>
    @if (otherText) {
      <span
      class="span-tooltip__other-text">({{otherText}})</span>
    }
  </span>
</p>
